module.exports = __webpack_public_path__ + "static/media/search1.49e61a6a.png";